export default {
  ADD: 1,
  EDIT: 2,
  VIEW: 3,
};
